const transitionAuto = require("@alexspirgel/transition-auto");

document.addEventListener('DOMContentLoaded', () => {
    const gptSearchBlocks = document.querySelectorAll('.block-gpt-search');
    gptSearchBlocks.forEach((gptSearchBlock, index) => {
        if (gptSearchBlock) {
            gptSearchBlock.classList.add('animations-activated');

            // Generate unique selector IDs for each block
            const chatFormContainerId = `chat-form-container-${index}`;
            const resultsContainerId = `results-container-${index}`;
            const chatResultContainerId = `chat-result-container-${index}`;
            const chatRecommendationsContainerId = `chat-recommendations-container-${index}`;

            // Assign unique IDs to elements within each block
            gptSearchBlock.querySelector('.chat-form-container').id = chatFormContainerId;
            gptSearchBlock.querySelector('.chat-result-container').id = chatResultContainerId;
            gptSearchBlock.querySelector('.chat-recommendations-container').id = chatRecommendationsContainerId;

            (async () => {
                const domainName = mqSettings?.modernquery_domain_name ?? 'www.easternstandard.com';
                let mqInstance = new ModernQuery({
                    labels: {
                        chat_button_submit: 'ASK A QUESTION',
                        chat_button_submit_after: 'ASK ANOTHER QUESTION'
                    },
                    selectors: {
                        chat_form_container: `#${chatFormContainerId}`,
                        results_container: `#${resultsContainerId}`,
                        chat_result_container: `#${chatResultContainerId}`,
                        chat_recommendations_container: `#${chatRecommendationsContainerId}`
                    },
                    elements: {
                        results_item: 'article'
                    },
                    results: {
                        title_parse: '| Eastern Standard',
                        title_parse_regex: false,
                        meta_description_as_snippet: true
                    },
                    callbacks: {
                        chat_text_render: {
                            before: () =>{
                                var chatResultAndRecommendationsContainer = gptSearchBlock.querySelector(`#${chatRecommendationsContainerId}`).parentNode.parentNode;
                                var parentElement = chatResultAndRecommendationsContainer.parentNode;
                                var closeButtonElement = parentElement.querySelector('.chatResultContainer-close-button');
                                if (closeButtonElement) {
                                    closeButtonElement.remove();
                                }
                            },
                            after: () => {
                                var block_gpt_search__content = gptSearchBlock.querySelector(`#${chatFormContainerId}`).parentNode.parentNode;
                                if (window.matchMedia("(max-width: 450px)").matches) {
                                    block_gpt_search__content.style.marginTop = '0';
                                }
                                transitionAuto({
                                    element: gptSearchBlock.querySelector(`#${chatRecommendationsContainerId}`).parentNode.parentNode,
                                    innerElement: gptSearchBlock.querySelector(`#${chatRecommendationsContainerId}`).parentNode,
                                    property: 'height',
                                    value: 'auto'
                                });
                                var chatResultContainer = gptSearchBlock.querySelector(`#${chatResultContainerId} span`);
                                if (chatResultContainer) {
                                    chatResultContainer.innerHTML = chatResultContainer.innerHTML.replace(
                                        'For more detailed information, you can always reference the links below.',
                                        ''
                                    );
                                    var newDiv = document.createElement('div');
                                    newDiv.className = 'chatResultContainer-contact-us';
                                    var newSpan = document.createElement('span');
                                    newSpan.className = 'chatResultContainer-span-class';
                                    newSpan.textContent = 'If you have specific questions or would like to discuss how we can assist you, feel free to ';
                                    var newLink = document.createElement('a');
                                    newLink.className = 'chatResultContainer-link-class';
                                    newLink.href = '/contact-us/';
                                    newLink.textContent = 'contact us';
                                    newDiv.appendChild(newSpan);
                                    newDiv.appendChild(newLink);
                                    chatResultContainer.appendChild(newDiv);

                                    // Create the close button with SVG and add a class to it
                                    var closeButton = document.createElement('button');
                                    closeButton.className = 'chatResultContainer-close-button';

                                    // SVG code for the X (close button)
                                    var svgContent = `
                                        <svg class="chatResultContainer-close-svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18 6L6 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M6 6L18 18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    `;

                                    // Insert the SVG into the button
                                    closeButton.innerHTML = svgContent;

                                    // Append the close button to the container
                                    var chatResultAndRecommendationsContainer = gptSearchBlock.querySelector(`#${chatRecommendationsContainerId}`).parentNode.parentNode;
                                    // var chat_result_container = gptSearchBlock.querySelector('.chat-result-container');
                                    // var chat_recommendations_container = gptSearchBlock.querySelector('.chat-recommendations-container');


                                    chatResultAndRecommendationsContainer.style.position = 'relative';
                                    var parentElement = chatResultAndRecommendationsContainer.parentNode;

                                    // Insert the close button right before the chat-result-and-recommendations-container
                                    if (!parentElement.querySelector('.chatResultContainer-close-button')) {
                                        parentElement.insertBefore(closeButton, chatResultAndRecommendationsContainer);
                                    }

                                    // Add click event to the close button to clear content
                                    closeButton.addEventListener('click', function() {
                                        var chat_result_containers = document.querySelectorAll('.chat-result-container');
                                        var chat_recommendations_containers = document.querySelectorAll('.chat-recommendations-container');
                                        chat_result_containers.forEach(function(element) {
                                            element.innerHTML = '';
                                        });
                                        chat_recommendations_containers.forEach(function(element) {
                                            element.innerHTML = '';
                                        });
                                        var closeButtons = document.querySelectorAll('.chatResultContainer-close-button');
                                        closeButtons.forEach(function(button) {
                                            button.remove();
                                        });
                                        closeButton.remove();
                                        var chatFormContainer = document.getElementById(chatFormContainerId);
                                        if (chatFormContainer) {
                                            // Find all input elements inside the chatFormContainer
                                            var inputs = chatFormContainer.querySelectorAll('input[type="text"]');
                                            // Loop through each input and clear its value
                                            inputs.forEach(function(input) {
                                                input.value = '';
                                            });
                                            }
                                    });

                                    setButtonWidth(gptSearchBlock);

                                }

                                setButtonWidth(gptSearchBlock);
                            }
                        }
                    }
                });

                mqInstance.setDomainName(domainName);
                mqInstance.setOrgName('Eastern Standard');
								mqInstance.setPropertyId( window.mqSettings?.modernquery_property_key ?? 'sg1v6iuv2d');
                mqInstance.chat.renderForm();
                mqInstance.events.apply();
            })();
        }
    });

    const openOverlayLink = document.querySelector('a[href="#ai-search"]');
    const overlay = document.getElementById('ai-search-overlay');
    const closeOverlayButton = document.getElementById('close-overlay');
    if (openOverlayLink && overlay && closeOverlayButton) {
        openOverlayLink.addEventListener('click', function (e) {
            e.preventDefault();
            overlay.style.display = 'block';
        });

        closeOverlayButton.addEventListener('click', function () {
            overlay.style.display = 'none';
        });
    }

    // New code to handle click on custom-link
    const customLink = document.querySelector('.custom-link');

    if (customLink) {
        customLink.addEventListener('click', function (e) {
            e.preventDefault();
            overlay.style.display = 'block';
        });
    }

});

function setButtonWidth(gptSearchBlock) {
    const button = gptSearchBlock.querySelector('.search-chat-submit');
    if (button) {
        if (window.innerWidth <= 715) {
            // Very small screens
            button.style.width = '100%';
        } else if (window.innerWidth <= 932) {
            // Medium screens
            button.style.width = '59%';
        }
    }
}
